<template>
  <div id="contenedor-listado-configuracion-firmas">
    <template v-if="loading">
      <v-skeleton-loader
        v-for="index in 4"
        :key="`firma-skeleton-${index}`"
        type="list-item-avatar-two-line"
        class="mb-2">
      </v-skeleton-loader>
    </template>
    <template
      v-else-if="!$vuetify.breakpoint.mobile">
      <desktop
        :listado="listado"
        v-on:eliminar="eliminarFirma">
      </desktop>
    </template>
    <template
      v-else>
      <mobile
        :listado="listado"
        v-on:eliminar="eliminarFirma">
      </mobile>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoConfiguracionFirmas',
  props: {
    listado: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Desktop,
    Mobile,
  },
  methods: {
    eliminarFirma(firma) {
      this.$emit('eliminar', firma);
    },
  },
};
</script>

<style lang="scss">
</style>
